const color = "#fff";

export default {
  getBase64FromUrl(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const urlParts = url.split(".");
        const ext = urlParts[urlParts.length - 1];
        var dataURL = canvas.toDataURL(`image/${ext}`);

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  },
  async companyHeader(textTitle, userCompany, color, vue) {
    return [
      {
        style: [this.getPdfStyles().tableMainHeaderStyle],
        table: {
          widths: ["60%", "40%"],
          body: [
            [
              {
                text: textTitle,
                style: [this.getPdfStyles().header],
                alignment: "left",
                border: [false, false, false, false],
                color: this.color,
                fillColor: color,
              },
              {
                text: userCompany.name,
                style: [this.getPdfStyles().subHeader],
                alignment: "right",
                border: [false, false, false, false],
                color: this.color,
                fillColor: color,
              },
            ],
            [
              {
                image: await this.getBase64FromUrl(vue.$store.getters.getLogo),
                border: [false, false, false, false],
                width: 75,
                fillColor: color,
              },
              {
                text: userCompany.primary_address,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color: this.color,
                fillColor: color,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color: this.color,
                fillColor: color,
              },
              {
                text: `${userCompany.city}, ${userCompany.postal_code}`,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color: this.color,
                fillColor: color,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color: this.color,
                fillColor: color,
              },
              {
                text: userCompany.primary_phone,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color: this.color,
                fillColor: color,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color: this.color,
                fillColor: color,
              },
              {
                text: userCompany.email,
                style: [this.getPdfStyles().email, this.getPdfStyles().italics],
                alignment: "right",
                border: [false, false, false, false],
                color: this.color,
                fillColor: color,
              },
            ],
          ],
        },
      },
      this.myCustomMarginHeaderBottom(),
    ];
  },
  dateAndPersonalInfo(
    client,
    invoiceDate,
    invoiceNumber,
    color,
    type = "Invoice"
  ) {
    return {
      style: [this.getPdfStyles().totalsPane],
      table: {
        widths: ["40%", "*", "*", "40%"],
        body: [
          [
            {
              border: [false, false, false, true],
              fillColor: color,
              color,
              text: `${client.name}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: color,
              color,
              text: `${client.position || "N/A"}`,
            },
          ],
          [
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Reference: ${client.client_reference}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `${client.institution || "N/A"}`,
            },
          ],
          [
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `${client.address}. ${client.city}, ${client.postal_code}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Date: ${invoiceDate} \n ${type} #: ${invoiceNumber}`,
            },
          ],
        ],
      },
    };
  },
  // itemsDetailsTable(selectedInvoice) {
  //   const items = selectedInvoice.items;

  //   const itemsTableBody = [this.myCustomMarginTop()];

  //   if (items.find((item) => item.item_type == "product")) {
  //     itemsTableBody.push(this.productsHeader());
  //     items.forEach((item) => {
  //       if (item.item_type == "product") {
  //         itemsTableBody.push(this.itemDetails(item));
  //       }
  //     });
  //   }

  //   if (items.find((item) => item.item_type == "service")) {
  //     itemsTableBody.push(this.servicesHeader());
  //     items.forEach((item) => {
  //       if (item.item_type == "service") {
  //         itemsTableBody.push(this.itemDetails(item));
  //       }
  //     });
  //   }

  //   if (items.find((item) => item.item_type == "transportation")) {
  //     itemsTableBody.push(this.transportsHeader());
  //     items.forEach((item) => {
  //       if (item.item_type == "transportation") {
  //         itemsTableBody.push(this.itemDetails(item));
  //       }
  //     });
  //   }

  //   return {
  //     style: [this.getPdfStyles().tableStyle, this.getPdfStyles().totalsPane],
  //     table: {
  //       widths: ["52%", "18%", "15%", "15%"],
  //       body: itemsTableBody,
  //     },
  //   };
  // },
  // tableTotalsPane(selectedInvoice, refNumber, color) {
  //   return {
  //     style: [this.getPdfStyles().tableStyle, this.getPdfStyles().totalsPane],
  //     table: {
  //       widths: ["40%", "*", 100, "40%"],
  //       body: [
  //         this.myCustomMarginTop(),
  //         [
  //           {
  //             border: [true, true, true, true],
  //             color,
  //             fillColor: color,
  //             text: `Banking Details`,
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },
  //           {
  //             border: [true, true, true, true],
  //             color,
  //             fillColor: color,
  //             text: `Computed Summary`,
  //           },
  //         ],
  //         [
  //           {
  //             border: [false, true, false, true],
  //             text: `Bank: ${userCompany.bank}`,
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },

  //           {
  //             border: [false, true, false, true],
  //             table: {
  //               widths: ["50%", "50%"],
  //               body: [
  //                 [
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `Sub Total:`,
  //                   },
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `${store.getters.getCurrency} ${selectedInvoice.subTotal}`,
  //                     alignment: "right",
  //                   },
  //                 ],
  //               ],
  //             },
  //           },
  //         ],
  //         [
  //           {
  //             border: [false, true, false, true],
  //             text: `Account #: ${userCompany.account_number}`,
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },
  //           {
  //             border: [false, true, false, true],
  //             table: {
  //               widths: ["50%", "50%"],
  //               body: [
  //                 [
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `Total Vat:`,
  //                   },
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `${store.getters.getCurrency}${selectedInvoice.totalTax}`,
  //                     alignment: "right",
  //                   },
  //                 ],
  //               ],
  //             },
  //           },
  //         ],

  //         [
  //           {
  //             border: [false, true, false, true],
  //             text: `Type: ${userCompany.account_type}`,
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },

  //           {
  //             border: [false, true, false, true],
  //             table: {
  //               widths: ["50%", "50%"],
  //               body: [
  //                 [
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `Discount:`,
  //                   },
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `${store.getters.getCurrency} ${selectedInvoice.discount}`,
  //                     alignment: "right",
  //                   },
  //                 ],
  //               ],
  //             },
  //           },
  //         ],
  //         [
  //           {
  //             border: [false, true, false, true],
  //             text: `Ref#: ${refNumber}`,
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },
  //           {
  //             border: [false],
  //             text: "",
  //           },

  //           {
  //             border: [false, true, false, true],
  //             table: {
  //               widths: ["50%", "50%"],
  //               body: [
  //                 [
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `Total:`,
  //                   },
  //                   {
  //                     border: [false, false, false, false],
  //                     text: `${store.getters.getCurrency} ${selectedInvoice.totalInvoiceAmount}`,
  //                     alignment: "right",
  //                   },
  //                 ],
  //               ],
  //             },
  //           },
  //         ],
  //       ],
  //     },
  //   };
  // },
  // productsHeader(color) {
  //   return [
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.products}`,
  //       alignment: "left",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.price}`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.quantity}`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `Line Total`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //   ];
  // },
  // servicesHeader(color) {
  //   return [
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.services}`,
  //       alignment: "left",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.fee}`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       alignment: "right",
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.duration}`,
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `Line Total`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //   ];
  // },
  // transportsHeader(color) {
  //   return [
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.transportations}`,
  //       alignment: "left",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.transportationFee} per ${store.getters.getCompanyLabels.distance}`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `${store.getters.getCompanyLabels.distance}`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //     {
  //       border: [true, true, true, true],
  //       fillColor: color,
  //       color,
  //       text: `Line Total`,
  //       alignment: "right",
  //       style: [this.getPdfStyles().addressSection],
  //     },
  //   ];
  // },
  // itemDetails(item) {
  //   return [
  //     {
  //       border: [false, true, false, true],
  //       text: `${item.name} ${
  //         item.category && item.category.name
  //           ? "\n[" + item.category.name + "]"
  //           : ""
  //       }`,
  //     },
  //     {
  //       border: [false, true, false, true],
  //       alignment: "right",
  //       text: `${store.getters.getCurrency}${item.price} \n ${
  //         item.increments ? "[" + item.increments + "]" : ""
  //       }`,
  //     },
  //     {
  //       border: [false, true, false, true],
  //       alignment: "right",
  //       text: `${item.quantity ? item.quantity : item.distance}`,
  //     },
  //     {
  //       border: [false, true, false, true],
  //       alignment: "right",
  //       text: `${store.getters.getCurrency}${item.lineTotal}`,
  //     },
  //   ];
  // },
  // getContent(description, selectedInvoice, selectedClient, invoiceDate) {
  //   const content = [];
  //   const innerContent = [];
  //   innerContent.push(this.companyHeader(description));

  //   if (selectedClient) {
  //     innerContent.push(
  //       this.dateAndPersonalInfo(
  //         selectedClient,
  //         invoiceDate,
  //         selectedInvoice.invoiceNumber,
  //         description
  //       )
  //     );
  //   }

  //   if (selectedInvoice.items && selectedInvoice.items.length > 0) {
  //     innerContent.push(this.itemsDetailsTable(selectedInvoice));
  //   }
  //   if (
  //     selectedInvoice.totalServices > 0 ||
  //     selectedInvoice.totalProducts > 0 ||
  //     selectedInvoice.totalTransports > 0
  //   ) {
  //     innerContent.push(
  //       this.tableTotalsPane(selectedInvoice, selectedInvoice.invoiceNumber)
  //     );
  //   }
  //   //if (selectedInvoice && selectedInvoice.description != description) {
  //   innerContent.push(this.commentLine(selectedInvoice.description));
  //   //}
  //   // if (userCompany.stamp) {
  //   //   innerContent.push(this.companyStamp());
  //   // }
  //   innerContent.push({
  //     text: `\n ${userCompany.name}`,
  //     alignment: "center",
  //   });
  //   innerContent.push({
  //     text: `\n created with BitsOffice [076 243 9441]`,
  //     alignment: "center",
  //   });
  //   content.push(innerContent);
  //   return content;
  // },
  commentLine(text) {
    return [
      {
        text: `\n ${text}`,
        alignment: "center",
      },
    ];
  },

  myCustomMarginHeaderBottom() {
    return [
      { text: "\n\n", border: [false, false, false, false] },
      { text: "\n\n", border: [false, false, false, false] },
    ];
  },
  myCustomMarginTop() {
    return [
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
    ];
  },
  getPdfStyles() {
    return {
      header: {
        fontSize: 28,
        bold: true,
        margin: [0, 0, 0, 0],
        color,
      },
      subHeader: {
        fontSize: 22,
        bold: true,
        margin: [0, 0, 0, 0],
        color,
      },
      addressSection: {
        fontSize: 14,
        margin: [0, 0, 0, 0],
        color,
        alignment: "left",
      },
      totalsPane: {
        fontSize: 14,
        margin: [0, 0, 0, 0],
        color: "#000",
        alignment: "left",
      },
      fillColumns: {
        margin: [0, 10, 0, 20],
      },
      tableStyle: {
        margin: [0, 0, 0, 0],
      },
      tableMainHeaderStyle: {
        fillColor: color,
        border: [false, false, false, false],
      },
      email: {
        fontSize: 12,
        color: "#2196F3",
        alignment: "center",
        decoration: "underline",
        margin: [0, 0, 0, 0],
      },
      quote: {
        italics: true,
      },
      small: {
        fontSize: 8,
      },
      paragraph: {
        fontSize: 12,
      },
      bold: {
        bold: true,
      },
      italics: {
        italics: true,
      },
      underline: {
        decoration: "underline",
      },
    };
  },
};
